import { Component, ViewEncapsulation, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeIconComponent } from '../ce-icon/ce-icon.component';
import { CePopoverImports } from '../ce-popover/ce-popover.component';
import { CePopoverCustomOverlay, CePopoverPosition } from '../ce-popover/ce-popover-trigger.directive';
import { CeButtonComponent } from '../ce-button/ce-button.component';

/**
 * The component accepts either text or component as signal input. If both are given, only component will be displayed.
 *
 * @deprecated Use `DsInfoButtonComponent` (`ds-info-button`) instead — it uses the post-DSD-245
 * icon-button sizing scale (`lg | md | sm | xs | 2xs`) and the new mobile touch overlay. See CBF-194.
 */
@Component({
    selector: 'ce-info-button',
    imports: [CommonModule, CeIconComponent, CePopoverImports, CeButtonComponent],
    templateUrl: './ce-info-button.component.html',
    styleUrl: './ce-info-button.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class CeInfoButtonComponent {
    /**
     * Component displayed inside the popover
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194).
     */
    // 'ngComponentOutlet' accepts only: Type<any> | null
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component = input<any>();

    /**
     * Text string displayed inside the popover
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194).
     */
    text = input<string>();

    /**
     * Popover's position relative to the trigger
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194).
     */
    position = input<CePopoverPosition>('above');

    /**
     * Trigger button's size
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194). Map `small`→`sm`, `medium`→`md`, `large`→`lg`.
     */
    size = input<'small' | 'medium' | 'large'>('medium');

    /**
     * Popover's width
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194).
     */
    popoverWidth = input<'8xl' | '9xl'>('8xl');

    /**
     * Whether trigger is disabled or not
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194).
     */
    disabled = input<boolean>();

    /**
     * Popover's padding
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194).
     */
    contentPadding = input<'xs' | 'sm' | 'md' | 'lg'>('md');

    /**
     * If the component is used inside dialog or in other full screen element, a custom overlay should be defined.
     * Otherwise, the popover will be the last element in DOM, and therefore not visible, since full screen elements use different layers.
     * 'Overlay selector' should be selector of the HTML element that is taking the full screen.
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194).
     */
    cePopoverCustomOverlay = input<CePopoverCustomOverlay>({
        enabled: false,
        overlaySelector: '',
    });

    /**
     * Whether popover is shown, when trigger is hovered.
     *
     * @deprecated Use `DsInfoButtonComponent` instead (CBF-194).
     */
    cePopoverWorksOnHover = input<boolean>(false);
}
